import PropTypes from 'prop-types';
import { SIDEBAR_PANE_DEFAULT, SIDEBAR_PANE_LIKES_LIST } from './consts';

export const SidebarPanes = PropTypes.oneOf([SIDEBAR_PANE_DEFAULT, SIDEBAR_PANE_LIKES_LIST]);
export const SelectedCommentStatus = PropTypes.oneOf([
    'creating',
    'editing',
    'saving',
    'deleting',
    'error',
]);

export const SelectedCommentEditingLocation = PropTypes.oneOf(['canvas', 'pane', null]);

export const DdoCommentProps = {
    isLoadingComments: PropTypes.bool.isRequired,
    comments: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
    selectedComment: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    selectedCommentStatus: SelectedCommentStatus,
    selectedCommentEditingLocation: SelectedCommentEditingLocation,
};



// WEBPACK FOOTER //
// ./src/js/apps/ddo/propTypes.js